/**
 * 全站http配置
 *
 * axios参数说明
 * isSerialize是否开启form表单提交
 * isToken是否需要token
 */
import axios from "axios";
import store from "@/store/";
import router from "@/router/router";
import { serialize } from "@/util/util";
import { getToken } from "@/util/auth";
import { Message } from "element-ui";
import website from "@/config/website";
import NProgress from "nprogress"; // progress bar
import "nprogress/nprogress.css"; // progress bar style
import { Base64 } from "js-base64";

let firstTig = false;

axios.defaults.timeout = 60000;
//返回其他状态吗
axios.defaults.validateStatus = function (status) {
  return status >= 200 && status <= 500; // 默认的
};
//跨域请求，允许保存cookie
axios.defaults.withCredentials = true;
// 设置baseUrl
// axios.defaults.baseURL = '/webapi'
// NProgress Configuration
NProgress.configure({
  showSpinner: false,
});
//HTTPrequest拦截
axios.interceptors.request.use(
  (config) => {
    NProgress.start(); // start progress bar
    const meta = config.meta || {};
    const isToken = meta.isToken === false;
    config.headers["Authorization"] = `Basic ${Base64.encode(
      `${website.clientId}:${website.clientSecret}`
    )}`;
    if (getToken() && !isToken) {
      config.headers["infox-Auth"] = "bearer " + getToken(); // 让每个请求携带token--['Authorization']为自定义key 请根据实际情况自行修改
    }
    //headers中配置serialize为true开启序列化
    if (config.method === "post" && meta.isSerialize === true) {
      config.data = serialize(config.data);
    }

    if (
      store.state.httpRules.openState &&
      store.getters.projectIdNedd(config.url)
    ) {
      // 此处加上配置  所有接口都必须带上 项目id
      switch (config.method) {
        case "put":
        case "post":
          if (!Array.isArray(config.data)) {
            config.data["projectId"] = store.state.httpRules.projectIdValue;
          }
          break;
        case "get":
          config.params["projectId"] = store.state.httpRules.projectIdValue;
          break;
      }
    }

    // config.metadata = {
    //   startTime: new Date()
    // }

    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);
//HTTPresponse拦截
axios.interceptors.response.use(
  (res) => {
    // // 在响应处理之前记录响应结束时间
    // res.config.metadata = res.config.metadata || {};
    // res.config.metadata.endTime = new Date();
    // // 计算请求时间
    // const duration = res.config.metadata.endTime - res.config.metadata.startTime;
    // // 将请求时间添加到响应数据中
    // res.data = { ...res.data, requestDuration: duration };

    // if (res.status === 500) {
    //   Message({
    //     message: "系统错误",
    //     type: "error",
    //   });
    //   return Promise.reject(new Error(message));
    // }
    NProgress.done();
    const status = res.data.code || 200;
    const statusWhiteList = website.statusWhiteList || [];
    const message = res.data.msg || "未知错误";
    //如果在白名单里则自行catch逻辑处理
    if (statusWhiteList.includes(status)) return Promise.reject(res);
    //如果是401则跳转到登录页面
    if (status === 401)
      store.dispatch("FedLogOut").then(() => router.push({ path: "/login" }));
    // 如果请求为非200否者默认统一处理
    if (status !== 200) {
      Message({
        message: message,
        type: "error",
      });
      return Promise.reject(new Error(message));
    }
    return res;
  },
  (error) => {
    //密码过期
    if (JSON.stringify(error).includes("510") && !firstTig) {
      firstTig = true;
      Message({
        message: "密码失效,请重新修改密码",
        type: "error",
      });
      setTimeout(() => {
        firstTig = false;
      }, 1000);
    }
    NProgress.done();
    return Promise.reject(new Error(error));
  }
);

export default axios;
